import { useEffect, useRef, useState } from "react";

import { useAdHeight } from "./useAdHeight";

/**
 * 自定义hook：处理Header滚动状态
 * 管理滚动相关的状态：isScrolled 和 isHeaderSticky
 * 添加滞后缓冲区防止触摸板连续滚动时的抖动
 */
export function useHeaderScroll() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isHeaderSticky, setIsHeaderSticky] = useState(false);
  const adHeight = useAdHeight();
  const adHeightRef = useRef(adHeight);

  adHeightRef.current = adHeight;

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;

      const newIsScrolled = scrollPosition > 0;
      setIsScrolled(newIsScrolled);

      const threshold = adHeightRef.current;
      const bufferZone = 100;

      setIsHeaderSticky((prevSticky) => {
        if (scrollPosition === 0) {
          return false;
        }

        if (!prevSticky) {
          return scrollPosition > threshold + bufferZone;
        } else {
          return scrollPosition > threshold - bufferZone;
        }
      });
    };

    handleScroll();

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return {
    isScrolled,
    isHeaderSticky,
    adHeight,
  };
}
